export const CAKE_MESSAGE_FONT_SIZE = "22px";

export const CAKE_SELECT_TEXT = {
    SELECT_CAKE: "Select Cake",
    CONFIRM: "Confirm",
    CANCEL: "Cancel",
    CONFIRM_MESSAGE: "Confirm message",
    SAVED: "Save Changes",
};

export const PREDEFINED_WORDS_SUFFIX = "...";

export const LABEL = "Cake message input";

export const CAKE_MESSAGE_INPUT_PLACEHOLDER = "Write your message here";
export const STATIC_MESSAGE = "Your message goes here";

export const IMAGE_DIMENSIONS = {
    WIDTH: "44px",
    HEIGHT: "44px",
};

export const EMOJI_REGEX = /(?:\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu;

export const SESSION_STORAGE_KEY = "cake_message";

export const STATIC_ASSETS_PATH = {
    FIRST_IMAGE: "portal/static-assets/hcms/mothers_day/25/cake.png",
    SECOND_IMAGE: "portal/static-assets/hcms/mothers_day/25/cake plus arrow.png",
    DEFAULT_PLACEHOLDER: "portal/static-assets/icons/cake.png",
};

export const SEPARATOR = " • ";

export const PRVEIW_IMAGE = {
    ALT: "Cake",
    WIDTH: "179px",
    HEIGHT: "100%",
};

export const ERROR_TEXT = "Character limit exceeded";
